import { Component, Input, OnInit, inject } from '@angular/core';
import { RoomData, StudySpacesService } from '../study-spaces.service';
import { IonicModule, ModalController } from '@ionic/angular';

import { TimetableComponent } from '../timetable/timetable.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-room-timetable',
  templateUrl: './room-timetable.page.html',
  styleUrls: ['./room-timetable.page.scss'],
  imports: [
    IonicModule,
    TimetableComponent,
    TranslatePipe
],
  providers: [
    StudySpacesService
  ]
})
export class RoomTimetablePage implements OnInit {
  private studySpacesService = inject(StudySpacesService);
  modalController = inject(ModalController);

  public roomData: RoomData = null;

  @Input()
  private buildingId: number | string;
  
  @Input()
  private roomId: number;

  public ngOnInit() {
    if(this.roomId) {
      this.studySpacesService.room(this.roomId, new Date()).subscribe((room: RoomData) => {
        this.roomData = room;
      })
    }
  }
}
